import * as authActionsConstants from '../../constants/actions/auth';
export function setDownloadTime(time) {
    return (dispatch) => {
        dispatch({ type: authActionsConstants.SET_START_DOWNLOAD_TIME, payload: {time} });
    };
}
